import Request from "../utils/request";

export const list = (data) => Request.get("/api/policy", data);
export const update = (data) => Request.put("/api/policy", data);